import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
// Key for registering and unregistering the subscriber
var MENTION_SUBSCRIBER_KEY = 'forge-ui-user-select';
var mentionResultsToUsers = function mentionResultsToUsers(results) {
  return results.map(function (result) {
    return {
      id: result.id,
      name: result.name,
      avatarUrl: result.avatarUrl || '',
      type: 'user'
    };
  }).filter(function (user) {
    return typeof user.name !== 'undefined';
  });
};

/**
 * A hook to query a mention resource that is provided from
 * a ProvidersFactory from Confluence
 */
export var useMentionResource = function useMentionResource(mentionProvider) {
  var query = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(search) {
      var provider;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return mentionProvider;
          case 2:
            provider = _context.sent;
            if (!(provider && search)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", new Promise(function (resolve) {
              provider.filter(search);
              provider.subscribe(MENTION_SUBSCRIBER_KEY, function (results) {
                provider.unsubscribe(MENTION_SUBSCRIBER_KEY);
                resolve(mentionResultsToUsers(results));
              }, function () {
                provider.unsubscribe(MENTION_SUBSCRIBER_KEY);
                resolve([]);
              });
            }));
          case 5:
            return _context.abrupt("return", Promise.resolve([]));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [mentionProvider]);
  if (mentionProvider) {
    return query;
  }
};